<ng-template #mainCta>
  @if (isSpinnerVisible$ | async) {
    <mat-spinner
      class="cta__spinner"
      [diameter]="24"
      color="white"></mat-spinner>
  } @else {
    @let isTrash = isTrashMenu();
    @let icon = isTrash ? 'trash' : 'add';
    @let text = isTrash ? 'list.menu.deleteAll' : 'list.menu.addFiles';

    <evc-icon
      class="cta__icon"
      [icon]="icon"
      size="md" />
    <span class="cta__text">
      {{ text | translate }}
    </span>
  }
</ng-template>

<div class="app">
  <evc-platform
    [i18nAppService]="i18nService"
    [inputAppIdentification]="appIdentification()"
    [inputSearch]="appSearch"
    [inputLeftBar]="leftBarConfig()"
    [inputHelpMenu]="appHelpMenu()"
    [inputSettingsMenu]="appSettingMenu"
    inputForcedTheme="light"
    class="app__header">
    <div leftbar-top-content>
      <evc-button
        data-testid="main-action-desktop"
        (click)="ctaButtonClicked('desktop')"
        class="main-action main-action--desktop"
        [attr.data-small]="!isLeftBarOpen()"
        size="large"
        [fullWidth]="true"
        [type]="isTrashMenu() ? 'neutral' : 'primary'"
        [disabled]="isTrashMenu() && (emptyList$ | async)">
        <ng-container *ngTemplateOutlet="mainCta"></ng-container>
      </evc-button>
      @if (isAddMenuOpenFrom === 'desktop') {
        <add-button-menu
          class="app__add-menu app__add-menu--desktop"
          evcCloseOnClickOutside
          [disableUpload]="uploading$ | async"
          (filesUpload)="uploadFiles($event)"
          (createFolder)="createFolder($event)"
          (clickedOutside)="hideAddMenu()" />
      }
    </div>

    <div mobile-main-action>
      <evc-button
        data-testid="main-action-mobile"
        (click)="ctaButtonClicked('mobile')"
        class="main-action main-action--mobile"
        type="primary"
        size="large"
        [disabled]="isTrashMenu() && (emptyList$ | async)">
        <ng-container *ngTemplateOutlet="mainCta"></ng-container>
      </evc-button>
      @if (isAddMenuOpenFrom === 'mobile') {
        <add-button-menu
          class="app__add-menu app__add-menu--mobile"
          evcCloseOnClickOutside
          [isGlobal]="true"
          [disableUpload]="uploading$ | async"
          (filesUpload)="uploadFiles($event)"
          (createFolder)="createFolder($event)"
          (clickedOutside)="hideAddMenu()" />
      }
    </div>

    <main class="app__container">
      @if (ready()) {
        <container class="app__content">
          <router-outlet></router-outlet>
        </container>
      }
    </main>
  </evc-platform>
</div>
